import React from "react";


function EmptyTodos() {
    return <p>!Crea tu primer Todo</p>
}

export default EmptyTodos;